module.exports = __webpack_public_path__ + "static/media/et-ru.76422022.mp4";